"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>CheckboxButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const useActionPanelContext_cjs_namespaceObject = require("../hooks/useActionPanelContext.cjs");
const index_cjs_namespaceObject = require("../../Checkbox/index.cjs");
function CheckboxButton(props) {
    const { name, value, disabled, required, checked = true, defaultChecked, onCheckedChange } = (0, useActionPanelContext_cjs_namespaceObject.useActionPanelContext)();
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CheckboxWithLabel, {
        name: `${name}-${value}`,
        value: value,
        checked: checked,
        size: "16",
        defaultChecked: defaultChecked,
        onCheckedChange: onCheckedChange,
        disabled: disabled,
        required: required,
        checkboxClassName: "focus-visible:outline-none disabled:text-primary-2 disabled:data-checked:text-primary-6 my-auto",
        labelNode: props.children,
        labelClassName: "gap-4",
        handleChange: ()=>{}
    });
}
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
